/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuHoursGroupInput } from '../../models/menu-hours-group-input';
import { MenuHoursGroupResult } from '../../models/menu-hours-group-result';

export interface MenuHoursGroupPut$Params {
  'Active-Tenant-Identifier': string;
  menuId: string;
  hoursId: string;
      body: MenuHoursGroupInput
}

export function menuHoursGroupPut(http: HttpClient, rootUrl: string, params: MenuHoursGroupPut$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuHoursGroupResult>> {
  const rb = new RequestBuilder(rootUrl, menuHoursGroupPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('menuId', params.menuId, {});
    rb.path('hoursId', params.hoursId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuHoursGroupResult>;
    })
  );
}

menuHoursGroupPut.PATH = '/menus/{menuId}/hours/{hoursId}';
